import { useBrandingConfig } from '@app/data/Branding';
import { updatePrimaryColor } from '@zeal/web-ui';
import { useEffect } from 'react';

export const useApplyBranding = () => {
	const { data: brandingConfig, isLoading: isBrandingConfigLoading } =
		useBrandingConfig();

	useEffect(() => {
		if (brandingConfig) {
			const primaryColor = brandingConfig?.theme?.primary_color;
			if (primaryColor) updatePrimaryColor(primaryColor);
		}
	}, [brandingConfig]);

	return { brandingConfig, isBrandingConfigLoading };
};
